/**
 * data-testid страницы товаров: плоский формат `Products.FinalTestId`.
 * Константы — финальные строки для элементов, с которыми работают e2e.
 * Без matcher-функций и без склейки / prop-drilling.
 */
export const productsTestIds = {
    loadedVariantNameCell: 'Products.LoadedVariantNameCell',
    multiActionBar: 'Products.MultiActionBar',
    variantsMenu: 'Products.VariantsMenu',
    unmergeVariants: 'Products.UnmergeVariants',
    archiveConfirmModal: 'Products.ArchiveConfirmModal',
    archiveCancel: 'Products.ArchiveCancel',
    unmergeConfirmModal: 'Products.UnmergeConfirmModal',
    unmergeConfirm: 'Products.UnmergeConfirm',
} as const;
